export default __webpack_public_path__ + "static/media/definix.81522795.svg";